module.exports = __webpack_public_path__ + "static/media/majorC6.3f1f7a9.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorC6.wav
// module id = 81w/
// module chunks = 0